<template>
  <gj-tree-manager
    title="标签分类"
    placeholder="请输入分类名称"
    :data="data"
    :add-icon="$permission('tagCategory:add')"
    :delete-icon="$permission('tagCategory:delete')"
    :edit-icon="$permission('tagCategory:edit')"
    :import-icon="$permission('tagCategory:add')"
    homeIcon
    :loading="loading"
    @queryData="selectAll"
    @import="importTagGroup"
    @add="addTagGroup"
    @delete="deleteTagGroup($event)"
    @edit="editTagGroup($event)"
    @node-click="select"
  ></gj-tree-manager>
</template>

<script>
import AppTagGroupImportModal from "../modal/tag-group-import-modal";
import AppTagGroupAddModal from "../modal/tag-group-add-modal";
import AppTagGroupDeleteModal from "../modal/tag-group-delete-modal";
import AppTagGroupEditModal from "../modal/tag-group-edit-modal";
import { getTagTreeList, tagCategoryDelete } from "../../../../../api/system";
import { responseMixin } from "../../../../../minxins";

export default {
  name: "app-tag-tree",
  mixins: [responseMixin],
  data() {
    return {
      data: [],
      name: null,
      confirmLoading: false,
      loading: false,
      nodeYes:{
        isCurrent:false
      },
      curNodeId:null,
      selectData:null
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.loading = true;
      getTagTreeList(this.name)
        .then((res) => {
          this.data = res.data;
        })
        .complete(() => (this.loading = false));
    },
    selectAll() {
        this.nodeYes.isCurrent = false;
        this.$emit("select", (this.curNodeId = null));
        this.selectData=null
    },
    select(data, node) {
      if (data) {
      // if (data&&this.curNodeId !== data.id) {
        this.$emit("select", (this.curNodeId = data.id));
        node.isCurrent = true;
        this.nodeYes=node
        this.selectData=data
      }
      // else {
      //   this.nodeYes.isCurrent = false;
      //   this.$emit("select", (this.curNodeId = null));
      //   this.selectData=null
      // }
    },
    importTagGroup() {
      const modal = this.$gjCreate(AppTagGroupImportModal, {
        on: {
          importFileSuccess: () => {
            this.queryData();
            this.$gjResetPage();
          },
          importSuccess: () => {
            this.queryData();
            modal.$gjDestroy();
          },
        },
      });
    },
    addTagGroup() {
      const modal = this.$gjCreate(AppTagGroupAddModal, {
        props:{
          selectData:this.selectData
        },
        on: {
          created: () => {
            this.queryData();
          },
        },
      });
    },
    deleteTagGroup(item) {
      // const modal = this.$gjCreate(AppTagGroupDeleteModal, {
      //   props: {
      //     item: item
      //   }
      // });
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: "warning",
          title: "删除标签分类",
          content: `将删除此标签分类以及其所有子级分类，删除后不可恢复；确定要删除吗？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            tagCategoryDelete(item.id)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success("删除成功");
                  this.queryData();
                  modal.$gjDestroy();
                });
              })
              .complete(() => {
                modal.confirmLoading = false;
              });
          },
        },
      });
    },
    editTagGroup(item) {
      const modal = this.$gjCreate(AppTagGroupEditModal, {
        props: {
          tag: item,
        },
        on: {
          created: () => {
            this.queryData();
          },
        },
      });
    },
  },
};
</script>

<style scoped>
 /deep/ .el-tree--highlight-current .el-tree-node .el-tree-node__content{
   color: #666666;
 }
</style>
